import {
    buildConversionData,
    buildPreConversionData,
    isSkyscanner,
    sendConversionEvent,
    sendPreConversionEvent
} from "./skyscanner";

// Same local ready() helper the rebuilt packs use (see
// packs/desktop/step2.js and step3.js) -- this body was already pure
// DOM, only its $(fn) wrapper was jQuery.
function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
}

ready(function () {
    if(!isSkyscanner()) return false;

    const currency = document.getElementsByTagName('body')[0].getAttribute('currency');

    // booking page -> conversion event
    const booking = document.getElementsByClassName("skyscanner-booking-information")[0];
    // const booking = document.getElementById("booking-information");
    if (booking) {
        const payload = buildConversionData(
            booking.getAttribute("data-adult-number"),
            booking.getAttribute("data-cabin-class"),
            booking.getAttribute("data-child-number"),
            booking.getAttribute("data-conversion-id"),
            currency,
            booking.getAttribute("data-fare-basis-codes"),
            booking.getAttribute("data-flight-fare"),
            booking.getAttribute("data-infant-number"),
            booking.getAttribute("data-legs"),
            booking.getAttribute("data-marketing-carriers"),
            booking.getAttribute("data-payment-method"),
            booking.getAttribute("data-route-type"),
            booking.getAttribute("data-transaction-total")
        );
        return sendConversionEvent(payload);
    }

    // Step2
    const step2 = document.getElementsByClassName("skyscanner-step2-data")[0];
    // const step2 = document.getElementById("step-2-data");
    if (step2) {
        const withinTolerance = document.getElementsByClassName("skyscanner-price-tolerance")[0];
        // const withinTolerance = document.getElementById("skyscanner-price-tolerance");
        if (withinTolerance) {
            const payload = buildPreConversionData(
                currency,
                step2.getAttribute("data-fare-basis-codes"),
                step2.getAttribute("data-marketing-carriers"),
                document.getElementsByClassName('total-amount')[0].innerText,
                "booking-page"
            );
            return sendPreConversionEvent(payload);
        } else {
            const payload = buildPreConversionData(
                currency,
                step2.getAttribute("data-fare-basis-codes"),
                step2.getAttribute("data-marketing-carriers"),
                document.getElementsByClassName('total-amount')[0].innerText,
                "recheckout-page"
            );
            return sendPreConversionEvent(payload);
        }
    }

    // homepage -> pre conversion event
    const homepage = document.getElementsByClassName("page_front")[0];
    if (homepage) {
        const payload = buildPreConversionData(
            currency,
            '',
            '',
            '0',
            'home-page'
        );
        return sendPreConversionEvent(payload);
    }
});
